var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistic-daily"},[_c('keep-alive',[_c(_vm.currentView,{tag:"component",on:{"startLoading":function($event){_vm.$startPageLoading($event)},"endLoading":function($event){_vm.$endPageLoading($event)}}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a63e710","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Statistics/StatisticDaily.vue
// module id = null
// module chunks = 